import(/* webpackMode: "eager", webpackExports: ["ContactDetails"] */ "/home/benning/Desktop/unchai-restaurant/src/app/contact/ContactDetails.tsx");
